import { createContext, useContext, type ReactNode } from "react";
import { cn } from "./utils";

const FormFieldLockStateContext = createContext(false);

export function FormFieldLockStateProvider({ locked, children }: { locked: boolean; children: ReactNode }) {
    return <FormFieldLockStateContext.Provider value={locked}>{children}</FormFieldLockStateContext.Provider>;
}

export function useFormFieldLocked(): boolean {
    return useContext(FormFieldLockStateContext);
}

/** Wrap inputs only. Label rows stay interactive so admins can unlock. */
export function FormFieldLockedRegion({ children, className }: { children: ReactNode; className?: string }) {
    const locked = useFormFieldLocked();
    return (
        <div className={cn(className)} inert={locked ? true : undefined}>
            {children}
        </div>
    );
}
